import { createSlice } from '@reduxjs/toolkit';

export interface IApp {
    allPagePopupForm: {
        isHidden: boolean,
    }
}

export const initialState: IApp = {
    allPagePopupForm: {
        isHidden: false,
    }
}

export const AppSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        update: (state, action) => {
            return {
                ...state,
                ...action.payload,
            }
        },
        hideAllPagePopupForm: (state) => {
            state.allPagePopupForm.isHidden = true;
            return state;
        },
        unhideAllPagePopupForm: (state) => {
            state.allPagePopupForm.isHidden = false;
            return state;
        },
    }
});

export const { 
    update, hideAllPagePopupForm, unhideAllPagePopupForm
} = AppSlice.actions;

export default AppSlice.reducer;